import styled from "styled-components";

// Full-viewport container for a Leaflet map page. Shared by home and pinmonkey lobby.
export const MapWrap = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  background: ${({ theme }) => theme.colors("background")};
`;
